import * as THREE from 'three';

// Continuously cycles forward through a list of colors (0 -> 1 -> 2 ->
// ... -> N-1 -> 0), rather than oscillating back and forth between just
// the first two - shared by the particle-based visualizers (NeonPulse,
// ParticleStorm, Tunnel) so their tint visibly steps through every color
// detected in the artwork's dominantColors, not just the first two.

const _a = new THREE.Color();
const _b = new THREE.Color();

// colors: array of hex ints (not THREE.Color - callers pass raw
// dominantColors/fallback hex arrays and let this do the conversion).
// speedPerSecond: fraction of the *full list* traversed per second, e.g.
// 1/33 means one complete pass through every color every ~33s regardless
// of how many colors are in the list.
export function cycleColor(colors, time, speedPerSecond, outColor) {
  const n = colors.length;
  const raw = time * speedPerSecond * n;
  const i0 = Math.floor(raw) % n;
  const i1 = (i0 + 1) % n;
  const localT = raw - Math.floor(raw);
  _a.set(colors[i0]);
  _b.set(colors[i1]);
  outColor.copy(_a).lerp(_b, localT);
  return outColor;
}
